import { useContext, createContext } from 'react';

export const TeamContext = createContext(null);

export function useTeamContext() {
  return useContext(TeamContext);
}
